module.exports = __webpack_public_path__ + "img/tour-54.cbd95b05.png";